// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { TEAM_NAME, RESOURCE_TYPE_NAME, PACKAGE_NAME } from './resourceTypeName.constants.tsx';

export const TARGET_FILTER_TYPE = 'com.atlassian.servicedesk:vp-origin';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const reportError = (error: any): void => {
	fireErrorAnalytics({
		error,
		sendToPrivacyUnsafeSplunk: true,
		meta: {
			id: RESOURCE_TYPE_NAME,
			packageName: PACKAGE_NAME,
			teamName: TEAM_NAME,
		},
	});
};
